import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-plan-expired-popup',
  imports: [DialogModule, ButtonModule, DropdownModule, PaginatorModule, RouterLink],
  templateUrl: './plan-expired-popup.component.html',
  styleUrl: './plan-expired-popup.component.scss',
})
export class PlanExpiredPopupComponent {
  onGoPremium() {
    this.ref.close();
  }

  constructor(public ref: DynamicDialogRef) {}
}
